import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-background-200/60">
      <div className="mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-7 h-7 flex items-center justify-center text-lg">
                <i className="ri-drop-fill" style={{ color: 'oklch(var(--accent-500))' }}></i>
              </span>
              <span className="text-base font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                奶水漫画
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              精选母婴哺乳主题原创漫画合集，<br />
              用温馨幽默的画风陪伴每一位妈妈的哺乳旅程。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors no-underline">首页</Link>
              <Link to="/category/breastfeeding-daily" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors no-underline">哺乳日常</Link>
              <Link to="/category/breastfeeding-knowledge" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors no-underline">母乳喂养知识</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors no-underline">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/parent-child-moments" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors no-underline">亲子互动</Link>
              <Link to="/category/new-mom-growth" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors no-underline">新手妈妈成长记</Link>
              <Link to="/category/funny-comics" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors no-underline">趣味育儿漫画</Link>
              <Link to="/category/illustrated-guide" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors no-underline">哺乳知识图解</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关注我们</h4>
            <p className="text-sm text-foreground-600 mb-3">
              每周更新2-3篇原创漫画，<br />
              陪伴你的育儿每一天。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 hover:bg-accent-200 transition-colors nofollow" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 hover:bg-accent-200 transition-colors nofollow" rel="nofollow" aria-label="微信公众号">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 hover:bg-accent-200 transition-colors nofollow" rel="nofollow" aria-label="小红书">
                <i className="ri-red-packet-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 奶水漫画 版权所有 | 本站漫画内容仅供阅读参考，不作为医学建议
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors no-underline nofollow" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors no-underline nofollow" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}